import './SelectionButton.css';
import { isIOS } from '../../services/isIOS';

export declare type SelectionButtonClickHandlerProps = {
  slug: string;
  target: HTMLButtonElement;
  setTargetValue: (v: string) => void;
  setIsButtonDisabled: (v: any) => void;
  [key: string]: any;
};

export type SelectionButtonProps = {
  slug: string;
  ariaLabel: string;
  selectionImage: string;
  selectionCard?: string;
  setTargetValue: (v: string) => void;
  setIsButtonDisabled: (v: any) => void;
  [key: string]: any;
};

export const btnClickHandler = ({
  event,
  slug,
  target,
  setTargetValue,
  setIsButtonDisabled,
  goToNextPage,
}: SelectionButtonClickHandlerProps) => {
  // console.log('btnClickHandler', target, slug);
  // TODO: background glow on select
  console.log('event', event);
  if (
    event.type === 'keydown' &&
    (event.key !== 'Space' || event.key !== 'Enter')
  ) {
    return;
  }
  document
    .querySelector('.selection-btn.selected')
    ?.classList.remove('selected');
  target.classList.add('selected');
  setTargetValue(slug);
  setIsButtonDisabled(false);
  goToNextPage();
  // target.classList.remove('selected');
  // eslint-disable-next-line react-hooks/exhaustive-deps
};

export function SelectionButton(props: SelectionButtonProps) {
  const {
    slug,
    ariaLabel,
    selectionImage,
    setTargetValue,
    setIsButtonDisabled,
    goToNextPage,
  } = props;

  const imgSrc = (slug: any) => {
    if (slug === 'squirtle' || slug === 'bulbasaur') {
      return `./static/media/global/img/common/characters/${slug}-crop.png`;
    } else if (slug === 'klawf') {
      return `./static/media/global/img/common/characters/${slug}-crop.svg`;
    } else {
      return `${selectionImage}`;
    }
  };
  return (
    <>
      <button
        className={`selection-btn ${slug}-selection-btn`}
        aria-label={ariaLabel}
        onClick={(event: any) =>
          btnClickHandler({
            event,
            slug,
            target: event.currentTarget,
            setTargetValue: setTargetValue,
            setIsButtonDisabled: setIsButtonDisabled,
            goToNextPage,
          })
        }
        onKeyDown={(event: any) =>
          btnClickHandler({
            event,
            slug,
            target: event.currentTarget,
            setTargetValue: setTargetValue,
            setIsButtonDisabled: setIsButtonDisabled,
            goToNextPage,
          })
        }
        value={slug}
        data-slug={slug}
      >
        <span className="selection-btn-background"></span>
        <span className="ios-background-span"></span>
        <span className="selection-btn-sprite-image-container">
          <span className="image">
            <img
              src={imgSrc(slug)}
              className="selection-btn-sprite-image"
              alt={ariaLabel}
              data-slug={slug}
            />
            {/* {selectionCard ? (
              <img
              src={`${lineDrip}`}
              className="selection-btn-linedrip"
              alt=""
              />
            ) : null} */}
          </span>
        </span>
        {/* </div> */}
      </button>
      <h2
        style={{ textAlign: 'center' }}
        aria-hidden={true}
        className={
          isIOS()
            ? 'selection-btn-character-name selection-btn-character-name-ios'
            : 'selection-btn-character-name'
        }
      >
        {ariaLabel}
      </h2>
    </>
  );
}
